import { Link } from "react-router-dom";
import { Calendar, MapPin, Users, Heart } from "lucide-react";
import { CATEGORY_LABEL, formatEventDate } from "../lib/categories";

export default function EventCard({ event, index = 0 }) {
  const { date, time } = formatEventDate(event.starts_at);
  return (
    <Link
      to={`/events/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className="card-warm fade-up block group"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden">
        {event.cover_image ? (
          <img
            src={event.cover_image}
            alt={event.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full" style={{ background: "var(--accent-2)" }} />
        )}
      </div>
      <div className="p-6 md:p-7">
        <div className="flex items-center justify-between mb-3">
          <span className="label-eyebrow">{CATEGORY_LABEL[event.category] || event.category}</span>
        </div>
        <h3 className="font-serif text-2xl md:text-[1.7rem] leading-snug" style={{ color: "var(--text-main)" }}>
          {event.title}
        </h3>
        <p className="text-sm mt-3 line-clamp-2" style={{ color: "var(--text-muted)" }}>
          {event.description}
        </p>
        <div className="divider-grain my-5" />
        <div className="grid grid-cols-2 gap-3 text-sm" style={{ color: "var(--text-main)" }}>
          <div className="flex items-center gap-2">
            <Calendar size={15} style={{ color: "var(--primary)" }} />
            <span>{date}</span>
          </div>
          <div className="flex items-center gap-2">
            <Users size={15} style={{ color: "var(--primary)" }} />
            <span>{event.interested_count || 0} interested</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin size={15} style={{ color: "var(--primary)" }} />
            <span className="truncate">{event.venue}</span>
          </div>
          <div className="flex items-center gap-2">
            <Heart size={15} style={{ color: "var(--primary)" }} />
            <span>{time}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
